import React, { Component } from "react";
import axios from "axios";
import ImageGallery from "react-image-gallery";
import { Row, Col } from "react-grid-system";

class StarNameApp extends Component {
  constructor(props) {
    super(props);
    this.state = {
      uid: props.match.params.uid,
      namecard: {
        addr: "",
        company: "",
        department: "",
        email: "",
        fax: "",
        homepage: "",
        idx: "",
        img_background: "",
        img_namecard: "",
        img_logo: "",
        mobile: "",
        name: "",
        position: "",
        tel: "",
      },
      info: {
        qrId: 0,
        qrkey: "",
        userId: 0,
      },
      buttons: [],
      slideimages: [],
      simages: [],

      showVideo: {},
      showGalleryPlayButton: true,
    };
  }

  componentDidMount() {
    this.getQrcodeInfo(this.state.uid);
  }

  getQrcodeInfo(uid) {
    console.log(uid);
    axios
      .post("https://happyqr.net/api/starname/api/getDefaultQrcodeInfo", {
        uid: uid,
      })
      .then((data) => {
        if (data.data.code == 200) {
          console.log(data.data);
          this.setState({
            namecard: data.data.namecard,
            info: data.data.info,
            buttons: data.data.buttons,
            slideimages: JSON.parse(data.data.info.images),
          });

          const images = [];
          const pro_images = JSON.parse(data.data.info.images);
          pro_images.map((item) => {
            if (item.search("youtu") == -1)
              images.push({
                original: item,
                renderItem: this._renderImage.bind(this),
              });
            else
              images.push({
                original:
                  "https://raw.githubusercontent.com/xiaolin/react-image-gallery/master/static/4v.jpg",
                embedUrl:
                  "https://www.youtube.com/embed/" +
                  item.replace("https://youtu.be/", ""),
                renderItem: this._renderVideo.bind(this),
              });
          });
          console.log(images);
          this.setState({ simages: images });
        }
      })
      .catch((error) => {
        console.log("error : ", error);
      });
  }

  _onSlide(index) {
    this._resetVideo();
    console.debug("slid to index", index);
  }

  _resetVideo() {
    this.setState({ showVideo: {} });

    if (this.state.showPlayButton) {
      this.setState({ showGalleryPlayButton: true });
    }

    if (this.state.showFullscreenButton) {
      this.setState({ showGalleryFullscreenButton: true });
    }

    var video = document.getElementsByClassName("yvideo");
    console.log(video.item);
    for (var i = 0; i < video.length; i++) {
      video
        .item(i)
        .contentWindow.postMessage(
          '{"event":"command","func":"stopVideo","args":""}',
          "*"
        );
    }
  }

  _toggleShowVideo(url) {
    this.state.showVideo[url] = !Boolean(this.state.showVideo[url]);
    this.setState({
      showVideo: this.state.showVideo,
    });

    if (this.state.showVideo[url]) {
      if (this.state.showPlayButton) {
        this.setState({ showGalleryPlayButton: false });
      }

      if (this.state.showFullscreenButton) {
        this.setState({ showGalleryFullscreenButton: false });
      }
    }
  }

  _renderImage(item) {
    return (
      <div className="image-gallery-image2">
        <img src={item.original} />
      </div>
    );
  }

  _renderVideo(item) {
    return (
      <div className="image-gallery-image">
        {
          <div className="video-wrapper">
            <iframe
              className="yvideo"
              width="560"
              height="315"
              src={item.embedUrl}
              frameBorder="0"
              allowFullScreen
            ></iframe>
          </div>
        }
      </div>
    );
  }

  renderHeader() {
    return <div>STAR NAME</div>;
  }

  getNameCardBackground() {
    if (this.state.namecard.img_background == 0) return "/template00.png";
    else if (this.state.namecard.img_background == 1) return "/template01.png";
    else if (this.state.namecard.img_background == 2) return "/template02.png";
    else if (this.state.namecard.img_background == 3) return "/template03.png";
    else if (this.state.namecard.img_background == 4) return "/template04.png";
    else if (this.state.namecard.img_background == 5) return "/template05.png";
    else if (this.state.namecard.img_background == 6) return "/template06.png";
    else if (this.state.namecard.img_background == 7) return "/template07.png";
    else if (this.state.namecard.img_background == 8) return "/template08.png";
    else if (this.state.namecard.img_background == 9) return "/template09.png";
    else if (this.state.namecard.img_background == 10) return "/template10.png";
    else if (this.state.namecard.img_background == 11) return "/template11.png";
    else if (this.state.namecard.img_background == 12) return "/template12.png";
    else if (this.state.namecard.img_background == 13) return "/template13.png";
    else return "/template00.png";
  }

  renderNameCard() {
    const info = this.state.namecard;
    if (info.img_namecard != null && info.img_namecard.length > 0) {
      return (
        <div
          style={{
            flex: 1,
            backgroundSize: "cover",
            backgroundImage: "url(" + this.getNameCardBackground() + ")",
          }}
        >
          <img
            src={info.img_namecard}
            style={{ width: "100%", height: "100%", backgroundSize: "cover" }}
          ></img>
        </div>
      );
    }
    return (
      <div
        style={{
          flex: 1,
          backgroundSize: "cover",
          backgroundImage: "url(" + this.getNameCardBackground() + ")",
        }}
      >
        {/** namecard top viewer */}
        <div
          style={{
            height: "50px",
            paddingLeft: "5%",
            paddingRight: "5%",
            paddingBottom: "5%",
            paddingTop: "2%",
          }}
        >
          <div style={{ width: "70%", height: "60px", float: "left" }}>
            <div
              style={{ height: "24px", fontWeight: "bold", fontSize: "large" }}
            >
              {" "}
              {info.company}{" "}
            </div>
            <div style={{ height: "18px" }}>
              {info.department} / {info.position}
            </div>
            <div style={{ height: "18px" }}>{info.name}</div>
          </div>
          <div
            style={{
              width: "30%",
              height: "60px",
              float: "right",
              textAlign: "right",
            }}
          >
            <img src={info.img_logo} style={{ width: 50, height: 50 }}></img>
          </div>
        </div>
        {/** namecard top viewer */}

        {/** namecard bottom viewer */}
        <div style={{ paddingLeft: "5%", paddingRight: "5%" }}>
          <div style={{ width: "100%" }}>
            <div style={{ float: "left", width: "45%" }}>
              M.{" "}
              {info.mobile.replace(
                /(^02.{0}|^01.{1}|[0-9]{3})([0-9]+)([0-9]{4})/,
                "$1-$2-$3"
              )}
            </div>
            <div style={{ float: "right", width: "55%" }}>E. {info.email}</div>
          </div>
          <br></br>
          <div style={{ width: "100%" }}>
            <div style={{ float: "left", width: "45%" }}>
              T.{" "}
              {info.tel.replace(
                /(^02.{0}|^01.{1}|[0-9]{3})([0-9]+)([0-9]{4})/,
                "$1-$2-$3"
              )}
            </div>
            <div style={{ float: "right", width: "55%" }}>
              F.{" "}
              {info.fax.replace(
                /(^02.{0}|^01.{1}|[0-9]{3})([0-9]+)([0-9]{4})/,
                "$1-$2-$3"
              )}
            </div>
          </div>
          <br></br>
          <div>A. {info.addr}</div>
          <div>H. {info.homepage}</div>
        </div>
      </div>
    );
  }

  renderGotoReg() {
    const imageClick = () => {
      console.log(this.state.info.userId);
      window.open("/Event01/" + this.state.info.userId);
    };
    return <img src="/event01.png" onClick={() => imageClick()} />;
  }

  renderImages() {
    return (
      <div style={{ flex: 1 }}>
        <ImageGallery
          items={this.state.simages}
          showThumbnails={false}
          showPlayButton={false}
          showFullscreenButton={false}
          showNav={true}
          onSlide={this._onSlide.bind(this)}
        />
      </div>
    );
  }

  getButton01Background(index) {
    switch (index) {
      case 0:
        return "#1abc9c";
      case 1:
        return "#2ecc71";
      case 2:
        return "#3498db";
      case 3:
        return "#9b59b6";
      case 4:
        return "#34495e";
      default:
        return "#1973D1";
    }
  }

  getButton02Background(index) {
    switch (index) {
      case 0:
        return "#f39c12";
      case 1:
        return "#d35400";
      case 2:
        return "#c0392b";
      case 3:
        return "#bdc3c7";
      case 4:
        return "#f1c40f";
      default:
        return "#1973D1";
    }
  }

  renderButtons() {
    const pro_buttons = this.state.buttons;

    let count = 0;
    let button01 = [];
    let button02 = [];

    pro_buttons.map((item) => {
      if (count < 5) button01.push(item);
      else button02.push(item);
      count++;
    });

    return (
      <div>
        <Row
          style={{
            width: "100%",
            marginLeft: 0,
            marginRight: 0,
          }}
        >
          {button01.map((item, index) => (
            <Col
              onClick={() => {
                if (item.value.length > 0) {
                  if (item.type == "link" || item.type == "file") {
                    if (item.value.startsWith("http")) window.open(item.value);
                    else window.open("http://" + item.value);
                  } else if (item.type == "tel") {
                    window.location.href = "tel:" + item.value;
                  } else if (item.type == "sms") {
                    window.location.href = "sms:" + item.value;
                  } else if (item.type == "mailto") {
                    window.location.href = "mailto:" + item.value;
                  }
                }
              }}
              style={{
                backgroundColor: this.getButton01Background(index),
                textAlign: "center",
                border: "0.02px solid black",
                paddingLeft: 10,
                paddingRight: 10,
              }}
            >
              {this.renderButtonIcon(item.icon)}
              <div style={{ color: "#fff", fontSize: 10 }}>{item.title}</div>
            </Col>
          ))}
        </Row>

        <Row style={{ width: "100%", marginLeft: 0, marginRight: 0 }}>
          {button02.map((item, index) => (
            <Col
              onClick={() => {
                if (item.value.length > 0) {
                  if (item.type == "link" || item.type == "file") {
                    if (item.value.startsWith("http")) window.open(item.value);
                    else window.open("http://" + item.value);
                  } else if (item.type == "tel") {
                    window.location.href = "tel:" + item.value;
                  } else if (item.type == "sms") {
                    window.location.href = "sms:" + item.value;
                  } else if (item.type == "mailto") {
                    window.location.href = "mailto:" + item.value;
                  }
                }
              }}
              style={{
                backgroundColor: this.getButton02Background(index),
                textAlign: "center",
                border: "0.02px solid black",
                paddingLeft: 10,
                paddingRight: 10,
              }}
            >
              {this.renderButtonIcon(item.icon)}
              <div style={{ color: "#fff", fontSize: 10 }}>{item.title}</div>
            </Col>
          ))}
        </Row>
      </div>
    );
  }

  renderButtonIcon(name) {
    console.log(name);
    return <i data-feather={name}></i>;
  }

  render() {
    return (
      <div className="app">
        <div className="main">
          {this.renderNameCard()}
          {this.renderImages()}
        </div>
        <div className="footer">{this.renderButtons()}</div>
      </div>
    );
  }
}

export default StarNameApp;
